module.exports = __webpack_public_path__ + "media/images/intro-374d2da25e923e633c8fb1640ac7a9c4.jpg";